import { Skeleton } from "@abodeminehq/parcel-ui";
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { AppNavigation } from '~/components/app/shared/navigation/app-navigation'
import { useAuthContext } from '~/contexts/auth-context'
import { OrgProvider, useOrg } from '~/contexts/org-context'

export const Route = createFileRoute('/org')({
  component: OrgLayout,
})

function OrgLayout() {
  const {isLoading, isAuthenticated, signIn} = useAuthContext()
  useEffect(() => {
   if(!isLoading && !isAuthenticated) {
    // Sign in from here rather than bouncing to home first: signIn() remembers
    // this URL, and this URL is the one that names the org.
    void signIn()
   }
  }, [isLoading, isAuthenticated, signIn])
  //check if you have access to this org
  // const {data: org} = useOrg()

  return (
    <div className="flex h-screen flex-col">
      {isLoading ? <Skeleton className="h-16" /> : <AppNavigation />}
      <main className="flex-1 overflow-auto flex flex-col">
        {isLoading ? <div>Loading...</div> : <Outlet />}
        {/* {!isLoading && <Outlet />} */}
      </main>
    </div>
  )
} 
